// takes a url data object and keeps it up to date with the current global fitment object
export const linkBuilders = {
    methods: {
        linkBuilder(obj) {
            // can't really do anything with this, just return whatever junk you gave us
            if (!obj || !obj.name) return obj

            const fitment = this.linkBuilderFitment
            const newObj = Object.assign({}, obj)

            if (newObj.name.includes('-mmy')) newObj.baseName = newObj.name.replace('-mmy', '')
            else {
                // check of this route newObj has the possability of fitment
                if (typeof newObj.hasFitmentRoute === 'undefined') {
                    newObj.hasFitmentRoute = this.hasFitmentRoute(newObj.name)
                    newObj.baseName = newObj.name
                }

                // no mmy version?  ok nevermind then
                if (!newObj.hasFitmentRoute) return newObj
            }

            newObj.name =
                // eslint-disable-next-line eqeqeq
                fitment.makeSlug && fitment.makeSlug != ''
                    ? `${newObj.baseName}-mmy`
                    : newObj.baseName

            if (newObj.params) {
                delete newObj.params.year
                delete newObj.params.makeSlug
                delete newObj.params.modelSlug
            }

            if (!newObj.params) newObj.params = {}

            if (fitment.year) newObj.params.year = fitment.year
            if (fitment.makeSlug) newObj.params.makeSlug = fitment.makeSlug
            if (fitment.modelSlug) newObj.params.modelSlug = fitment.modelSlug

            return newObj
        },
        hasFitmentRoute(targetRouteName) {
            let found = false

            this.$router.options.routes.forEach((route) => {
                if (routeIsFitable(route, targetRouteName)) found = true
                if (route.children && !found) {
                    route.children.forEach((childRoute) => {
                        if (routeIsFitable(childRoute, targetRouteName)) found = true
                    })
                }
            })

            return found
        },
    },
    computed: {
        linkBuilderFitment() {
            return this.$store.state.fitment.data
        },
    },
}

const routeIsFitable = (route, targetRouteName) => {
    // eslint-disable-next-line eqeqeq
    return route.name == targetRouteName && route.meta && route.meta.isFitable
}

export const maxQty = function (qty) {
    return qty > 10 ? qty : 10
}
